import { render } from "./SimpleIconHero.vue?vue&type=template&id=163bd32e"
import script from "./SimpleIconHero.vue?vue&type=script&lang=js"
export * from "./SimpleIconHero.vue?vue&type=script&lang=js"

import "./SimpleIconHero.vue?vue&type=style&index=0&id=163bd32e&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/ContentCreator/Hero/SimpleIconHero.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "163bd32e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('163bd32e', __exports__)) {
    api.reload('163bd32e', __exports__)
  }
  
  module.hot.accept("./SimpleIconHero.vue?vue&type=template&id=163bd32e", () => {
    api.rerender('163bd32e', render)
  })

}


export default __exports__